// Placeholder integration health — wired to real signals in later phases.

interface Item {
  tone: 'ok' | 'warn' | 'err';
  label: string;
}

const ITEMS: Item[] = [
  { tone: 'ok', label: 'WhatsApp connected' },
  { tone: 'ok', label: 'DMS MCP connected' },
  { tone: 'ok', label: 'CRM MCP connected' },
  { tone: 'warn', label: 'ERP MCP degraded' },
];

const TONE_CSS: Record<Item['tone'], string> = {
  ok: 'var(--ok)',
  warn: 'var(--warn)',
  err: 'var(--err)',
};

export function StatusBar() {
  return (
    <footer
      className="flex items-center px-5 h-[30px] gap-[18px] text-[11.5px] text-text-3 border-t border-border"
      style={{ background: 'var(--surface)' }}
    >
      {ITEMS.map((it) => (
        <span key={it.label} className="flex items-center gap-1.5">
          <span
            className="inline-block w-1.5 h-1.5 rounded-full"
            style={{ background: TONE_CSS[it.tone] }}
          />
          {it.label}
        </span>
      ))}
      <span className="ml-auto cursor-pointer hover:text-text-2">2 alerts</span>
    </footer>
  );
}
